var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-sheet', {
    attrs: {
      "color": "white"
    }
  }, [_c('section', {
    staticClass: "section section--1"
  }, [_c('v-container', [_c('hunt-visual'), _c('hunt-reward', {
    staticClass: "mt-80px mt-md-160px mt-lg-190px"
  }), _c('hunt-winner-slide', {
    staticClass: "mt-80px mt-md-160px mt-lg-190px",
    attrs: {
      "logs": _vm.logs,
      "ranking": _vm.ranking
    }
  }), _c('hunt-event', {
    staticClass: "mt-80px mt-md-160px mt-lg-190px"
  })], 1)], 1), _c('section', {
    staticClass: "section section--2"
  }, [_c('v-container', [_c('v-layout', {
    staticClass: "section--2__inner text-center",
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('h2', {
    staticClass: "tit mb-4 mb-md-6",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 나누리 캐시 "), _c('br'), _vm._v(" & 나누리 상품권 사용방법 ")]), _c('h4', {
    staticClass: "tit tit--xs grey-7d--text mb-6px",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 50 : 0
    }
  }, [_vm._v(" 대한문고 홈페이지에서 다양한 상품으로 교환 가능합니다. ")]), _c('p', {
    staticClass: "txt grey-7d--text font-weight-medium mb-3 mb-md-5",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 100 : 0
    }
  }, [_c('span', {
    staticClass: "font-size-12 d-inline-block pr-1"
  }, [_vm._v("▶")]), _vm._v(" 홈페이지 접속 → 로그인 → 나누리 충전 → 핀 번호 입력 → 교환소에서 사용 ")]), _c('v-btn', {
    attrs: {
      "large": "",
      "rounded": "",
      "color": "primary",
      "data-aos": "fade-up",
      "data-aos-duration": "700",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 150 : 0,
      "to": "/gshop/brand"
    }
  }, [_c('span', {
    staticClass: "inline-block mr-1"
  }, [_vm._v("나누리 상품권 사용하기")]), _c('right-arrow')], 1), _c('v-img', {
    staticClass: "tube w-100",
    attrs: {
      "src": "/images/event/hunt/tube.png",
      "max-width": "152",
      "aspect-ratio": 152 / 146
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "section section--3"
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('h2', {
    staticClass: "tit mb-4 mb-md-6 text-center",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 꼭 알아두세요! ")]), _c('v-sheet', {
    attrs: {
      "max-width": "640",
      "data-aos": "fade-up",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 50 : 0
    }
  }, [_c('ul', {
    staticClass: "dot-txts txt"
  }, [_c('li', {
    staticClass: "dot-txt"
  }, [_vm._v(" 해당 이벤트는 한 ID당 1일 1회 참여 가능합니다. ")]), _c('li', {
    staticClass: "dot-txt"
  }, [_vm._v(" 부적절한 방법을 통해 이벤트 참여 시 이벤트 대상에서 제외됩니다. ")]), _c('li', {
    staticClass: "dot-txt"
  }, [_vm._v(" 나누리 캐시는 당첨 즉시 발송되며, '마이페이지 → 캐시선물내역 → 받은내역' 에서 받기 후 사용하실 수 있습니다. ")]), _c('li', {
    staticClass: "dot-txt"
  }, [_c('strong', [_vm._v("1, 2등 당첨 시 제세공과금(상품가격의 22%)이 부과")]), _vm._v("되며, 처리를 위해 신분증 사본을 요청할 수 있습니다.또한 1, 2등 경품은 해당 이벤트 종료 후 일괄 배송됩니다. ")]), _c('li', {
    staticClass: "dot-txt"
  }, [_vm._v(" 3,4등 경품은 참여 다음날 지급되며, 주말 참여 시 차주 월요일에 순차 지급됩니다. ")]), _c('li', {
    staticClass: "dot-txt"
  }, [_vm._v(" 나누리 상품권은 모바일 상품권으로 홈페이지에서 충전 후 사용 가능합니다. ")]), _c('li', {
    staticClass: "dot-txt"
  }, [_vm._v(" 당첨되신 경품은 즉시 사용가능하며 유효기간 이후에는 사용이 불가합니다. ")]), _c('li', {
    staticClass: "dot-txt"
  }, [_vm._v(" 해당 이벤트는 경품 소진 시 세부 일정 변경 및 조기 종료될 수 있습니다. ")]), _c('li', {
    staticClass: "dot-txt"
  }, [_vm._v(" 유의 사항 미숙지 및 회원정보 오류로 인한 경품 미수신 시 재발송이 불가합니다. ")])])]), _c('v-img', {
    staticClass: "mt-80px mt-md-120px mt-lg-160px w-220px w-md-380px",
    attrs: {
      "src": "/images/logo.png",
      "max-width": "100%",
      "aspect-ratio": 380 / 36,
      "contain": ""
    }
  })], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }